/**
 * очень странный фикс кодировки в виде комментария на русском языке UTF-8
 * https://github.com/bitrix-tools/cli/issues/2
 */

import { BitrixVue } from 'ui.vue3';
import BlogComponent from "./components/Blog.js";

export class Blog {
    #blog;

    constructor(rootNode) {
        this.rootNode = document.querySelector(rootNode);
    }

    start() {
        this.attachTemplate();
    }

    attachTemplate() {
        this.#blog = BitrixVue.createApp({
            components: {
                BlogComponent,
            },
            template: `
				<BlogComponent/>
			`,
        });

        this.#blog.mount(this.rootNode);

    }
}